export const LockedCell = () => <span className="director-dashboard-locked">Complete o estoque</span>;

export const Note = ({ children, tone }) => <small className="director-dashboard-note" data-tone={tone}>{children}</small>;
